import React, { useEffect } from 'react';
import { useUserRewardStore } from 'lib/store/userRewardStore';
import { FragmentsUsedType } from 'lib/constants/fragment';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { showIndependentModal } from '../Modal';
import IndependentDialog from '../IndependentDialog';
import { showDebrisDetailDialog } from '../DebrisDetailDialog';
import './index.scss';
interface DebrisRecordDialogProps {
  title: string;
  bottomText: string;
  confirmButtonText?: string;
  closeModal?: () => void;
}

const DebrisRecordDialog = ({ title, closeModal, bottomText }: DebrisRecordDialogProps) => {
  const { usedFragmentList, queryUsedFragmentPrizeResult } = useUserRewardStore();
  const limit = 99; // 每页显示的数量

  useEffect(() => {
    report(ATTA_REPORT.USED_DEBRIS_LIST.SHOW);
    fetchData();
  }, []);

  const fetchData = async () => {
    await queryUsedFragmentPrizeResult({ limit });
  };

  const showDetail = (item) => {
    // 不显示详情
    return;
  };
  return (
    <IndependentDialog
      showConfirm={false}
      title={title}
      customClass="independent-modal-dialog__fullWidth"
      closeModal={closeModal}
    >
      <div className="debris-record-dialog">
        {usedFragmentList?.length ? (
          <ul className="debris-record-dialog__list">
            {usedFragmentList.map((item: any, index) => (
              <li
                onClick={() => showDetail(item)}
                className="debris-record-dialog__list__li"
                key={index + item.id + item.usedTime}
              >
                <img src={item.currencyIcon} alt="" />
                <div className="debris-record-dialog__list__li__info">
                  <div className="debris-record-dialog__list__li__info__name">
                    {`${item.currencyName}*${item.usedAmount}`}
                  </div>
                  <div className="debris-record-dialog__list__li__info__expireTime">
                    {`${item.usedType === FragmentsUsedType.USER_USE ? '使用时间：' : '过期时间：'}${item.usedTime}`}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="empty-dialog">
            <img
              className="empty-dialog__icon"
              src="https://act.ecovision.gtimg.com/static/imgs/static/static_1720144820422.png"
              alt="[图片]"
            />
            <div>空空如也</div>
            <div>快去参与一下～</div>
          </div>
        )}

        <div className="debris-record-dialog__bottomText">{bottomText}</div>
      </div>
    </IndependentDialog>
  );
};

export const showDebrisRecordDialog = ({
  title,
  confirmButtonText = '确认',
  bottomText = '仅展示最近99条记录～',
  closeModal = () => { },
}) => showIndependentModal(
  <DebrisRecordDialog
    title={title}
    bottomText={bottomText}
    confirmButtonText={confirmButtonText}
    closeModal={closeModal}
  />,
  { onBottom: true },
);
